import React from "react";
export const filterByRegion = (market) => ({ name }) => name === market.region;
export const groupRegions = (regions, market) => {
    let regionArray = [];
    if (!regions.some(filterByRegion(market))) {
        const region = {
            name: market.region,
            countries: [],
        };
        region.countries.push(market);
        regionArray = [...regions, region];
        return regionArray;
    }
    const filteredRegion = regions.find(filterByRegion(market));
    const filteredRegionIndex = regions.findIndex(filterByRegion(market));
    if (!filteredRegion)
        return regions;
    filteredRegion.countries.push(market);
    regions[filteredRegionIndex] = filteredRegion;
    return regions;
};
export const styleByPipe = (market) => {
    const [country, language] = market.split(" | ");
    return (React.createElement(React.Fragment, null,
        React.createElement("span", null, country),
        !!language && (React.createElement(React.Fragment, null,
            " ",
            React.createElement("span", null,
                "(",
                language,
                ")")))));
};
